export enum LABEL_STYLE {
  FILL = "fill",
  LIGHT = "light",
  TEXT = "text",
  OUTLINE = "outline",
}

export enum LABEL_COLOR {
  DEFAULT = "default",
  BRAND = "brand",
  ACCENT = "accent",
  DANGER = "danger",
  SUCCESS = "success",
  WARNING = "warning",
  INFO = "info",
}

export enum LABEL_TYPE {
  SQUARE = "square",
  ROUND = "round",
}

export enum LABEL_SIZE {
  XLARGE = "xlarge",
  LARGE = "large",
  SMALL = "small",
  MEDIUM = "medium",
  XSMALL = "xsmall",
}
